import { createAction, props } from '@ngrx/store';
import {
  CreateBookingParam,
  GetAllBookingsByStatusParam,
  GetAllBookingsBetweenDatesParam,
  UpdateBookingParam,
  GetAllBookingsByVendorDocumentParam,
  GetAllBookingsByResidentAndStatusParam,
  GetAllBookingsBetweenDatesAndBuildingIdParam,
  GetAllBookingsByBuildingIdParam,
  AssignVendorToBookingParam,
  ValidateBookingAccessCodeParam,
  DownloadBookingsReportByBuildingIdParam,
  UpdateBookingProcessStatusParam,
  GetAllBookingsByResidentParam,
  AssignVendorCompanyToBookingParam,
} from '@resident-select/domain/booking';
import {} from '@resident-select/domain/vendor-company';
import { SciGuaduaTransaction } from '@scifamek/guadua';

export const CreateBookingCommand = createAction(
  'CreateBookingCommand',
  props<SciGuaduaTransaction<CreateBookingParam>>(),
);

export const UpdateBookingCommand = createAction(
  'UpdateBookingCommand',
  props<SciGuaduaTransaction<UpdateBookingParam>>(),
);

export const AssignVendorToBookingCommand = createAction(
  'AssignVendorToBookingCommand',
  props<SciGuaduaTransaction<AssignVendorToBookingParam>>(),
);

export const AssignVendorCompanyToBookingCommand = createAction(
  'AssignVendorCompanyToBookingCommand',
  props<SciGuaduaTransaction<AssignVendorCompanyToBookingParam>>(),
);

export const GetAllBookingsByStatusCommand = createAction(
  'GetAllBookingsByStatusCommand',
  props<SciGuaduaTransaction<GetAllBookingsByStatusParam>>(),
);

export const GetAllBookingsBetweenDatesCommand = createAction(
  'GetAllBookingsBetweenDatesCommand',
  props<SciGuaduaTransaction<GetAllBookingsBetweenDatesParam>>(),
);

export const GetAllBookingsByVendorDocumentCommand = createAction(
  'GetAllBookingsByVendorDocumentCommand',
  props<SciGuaduaTransaction<GetAllBookingsByVendorDocumentParam>>(),
);

export const GetAllBookingsByResidentAndStatusCommand = createAction(
  'GetAllBookingsByResidentAndStatusCommand',
  props<SciGuaduaTransaction<GetAllBookingsByResidentAndStatusParam>>(),
);

export const GetAllBookingsBetweenDatesAndBuildingIdCommand = createAction(
  'GetAllBookingsBetweenDatesAndBuildingIdCommand',
  props<SciGuaduaTransaction<GetAllBookingsBetweenDatesAndBuildingIdParam>>(),
);

export const GetAllBookingsByBuildingIdCommand = createAction(
  'GetAllBookingsByBuildingIdCommand',
  props<SciGuaduaTransaction<GetAllBookingsByBuildingIdParam>>(),
);

export const ValidateBookingAccessCodeCommand = createAction(
  'ValidateBookingAccessCodeCommand',
  props<SciGuaduaTransaction<ValidateBookingAccessCodeParam>>(),
);

export const DownloadBookingsReportByBuildingIdCommand = createAction(
  'DownloadBookingsReportByBuildingIdCommand',
  props<SciGuaduaTransaction<DownloadBookingsReportByBuildingIdParam>>(),
);

export const UpdateBookingProcessStatusCommand = createAction(
  'UpdateBookingProcessStatusCommand',
  props<SciGuaduaTransaction<UpdateBookingProcessStatusParam>>(),
);

export const GetAllBookingsByResidentCommand = createAction(
  'GetAllBookingsByResidentCommand',
  props<SciGuaduaTransaction<GetAllBookingsByResidentParam>>(),
);
